import styled from 'styled-components';
import { JsonViewModeContextProvider, ViewTypes, JsonView } from 'ui/treeView';
import { spacing, colors } from 'ui/theme';
import { CampaignFormField, ReadOnlyField } from '../../FormFields';

import { LightText } from '../Sections.styled';

const JsonViewWrapper = styled.div`
  border-radius: ${spacing.half};
  margin: ${spacing.half} ${spacing.base};
  padding: ${spacing.base};
  border: ${spacing.single} solid ${colors.grey15};
  overflow: hidden;
  background-color: ${colors.grey10};
  position: relative;
  width: 100%;
`;

type RawJsonViewerProps = {
  payload?: string;
};

export const RawJsonViewer = ({ payload }: RawJsonViewerProps) => (
  <CampaignFormField labelText="Raw data (JSON)">
    <ReadOnlyField name="payload">
      {payload && payload !== '{}' ? (
        <JsonViewWrapper>
          <JsonViewModeContextProvider identifier="raw-data" defaultMode={ViewTypes.raw}>
            <JsonView src={JSON.parse(payload)} showToggle={false} />
          </JsonViewModeContextProvider>
        </JsonViewWrapper>
      ) : (
        <LightText>Not set</LightText>
      )}
    </ReadOnlyField>
  </CampaignFormField>
);
